import {
  GET_FACILITY,
  GET_FACILITY_SUCCESS,
  GET_FACILITY_ERROR,
} from './../../actionType'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const GetCouponFacility = (state = initialState, action) => {
  switch (action.type) {
    case GET_FACILITY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case GET_FACILITY_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case GET_FACILITY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default GetCouponFacility
